module.exports = __webpack_public_path__ + "img/player-stats-group-wm.0d34e714.png";